// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 4.4.19
   Code Gen Name   PerformanceManagement
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     10/6/2022 10:04:13 AM
************************************************/

export enum PerformanceManagementMetaDataItemNames {
    EmployeeReview = 'EmployeeReview',
    EmployeeReviewAnswer = 'EmployeeReviewAnswer',
    EmployeeReviewAnswerValue = 'EmployeeReviewAnswerValue',
    EmployeeReviewCategory = 'EmployeeReviewCategory',
    EmployeeReviewQuestion = 'EmployeeReviewQuestion',
    EmployeeReviewQuestionRequest = 'EmployeeReviewQuestionRequest',
    EmployeeReviewQuestionRequestDetail = 'EmployeeReviewQuestionRequestDetail',
    EmployeeReviewQuestionRequestStatus = 'EmployeeReviewQuestionRequestStatus',
    EmployeeReviewQuestionSetup = 'EmployeeReviewQuestionSetup',
    EmployeeReviewQuestionSetupDetail = 'EmployeeReviewQuestionSetupDetail',
    EmployeeReviewQuestionSetupLevel = 'EmployeeReviewQuestionSetupLevel',
    EmployeeReviewQuestionSkill = 'EmployeeReviewQuestionSkill',
    EmployeeReviewQuestionType = 'EmployeeReviewQuestionType',
    EmployeeReviewStatus = 'EmployeeReviewStatus',
    EmployeeReviewSummary = 'EmployeeReviewSummary',
    EmployeeReviewSummaryStatus = 'EmployeeReviewSummaryStatus',
    EmployeeReviewSummaryType = 'EmployeeReviewSummaryType',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    EthosWachterTeam = 'Ethos_WachterTeam',
    RoEmployeeReviewSummaryCurrent = 'roEmployeeReviewSummaryCurrent',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    WachterContainerStyle = 'WachterContainerStyle',
}

export enum PerformanceManagementMetaDataLookups {
    EmployeeReviewQuestionApprovedQuestions = 1767,
    EmployeeReviewAllItems = 1741,
    EmployeeReviewAnswerAllItems = 1748,
    EmployeeReviewAnswerValueAllItems = 1745,
    EmployeeReviewCategoryAllItems = 1746,
    EmployeeReviewQuestionAllItems = 1747,
    EmployeeReviewQuestionRequestAllItems = 1762,
    EmployeeReviewQuestionRequestDetailAllItems = 1763,
    EmployeeReviewQuestionRequestStatusAllItems = 1761,
    EmployeeReviewQuestionSetupAllItems = 1765,
    EmployeeReviewQuestionSetupDetailAllItems = 1766,
    EmployeeReviewQuestionSetupLevelAllItems = 1764,
    EmployeeReviewQuestionSkillAllItems = 1760,
    EmployeeReviewQuestionTypeAllItems = 1749,
    EmployeeReviewStatusAllItems = 1740,
    EmployeeReviewSummaryAllItems = 1744,
    EmployeeReviewSummaryStatusAllItems = 1743,
    EmployeeReviewSummaryTypeAllItems = 1742,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterTeamNSPLBU = 1709,
    EthosWachterTeamAllItems = 1415,
    RoEmployeeReviewSummaryCurrentAllItems = 1789,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    WachterContainerStyleAllItems = 1752,
    WachterTeamByDepartment = 1768,
    WachterTeamDepartment = 1496,
}

@Injectable({
    providedIn: 'root'
})
export class PerformanceManagementMetaDataService {

    EmployeeReview : EmployeeReview = new EmployeeReview();
    EmployeeReviewAnswer : EmployeeReviewAnswer = new EmployeeReviewAnswer();
    EmployeeReviewAnswerValue : EmployeeReviewAnswerValue = new EmployeeReviewAnswerValue();
    EmployeeReviewCategory : EmployeeReviewCategory = new EmployeeReviewCategory();
    EmployeeReviewQuestion : EmployeeReviewQuestion = new EmployeeReviewQuestion();
    EmployeeReviewQuestionRequest : EmployeeReviewQuestionRequest = new EmployeeReviewQuestionRequest();
    EmployeeReviewQuestionRequestDetail : EmployeeReviewQuestionRequestDetail = new EmployeeReviewQuestionRequestDetail();
    EmployeeReviewQuestionRequestStatus : EmployeeReviewQuestionRequestStatus = new EmployeeReviewQuestionRequestStatus();
    EmployeeReviewQuestionSetup : EmployeeReviewQuestionSetup = new EmployeeReviewQuestionSetup();
    EmployeeReviewQuestionSetupDetail : EmployeeReviewQuestionSetupDetail = new EmployeeReviewQuestionSetupDetail();
    EmployeeReviewQuestionSetupLevel : EmployeeReviewQuestionSetupLevel = new EmployeeReviewQuestionSetupLevel();
    EmployeeReviewQuestionSkill : EmployeeReviewQuestionSkill = new EmployeeReviewQuestionSkill();
    EmployeeReviewQuestionType : EmployeeReviewQuestionType = new EmployeeReviewQuestionType();
    EmployeeReviewStatus : EmployeeReviewStatus = new EmployeeReviewStatus();
    EmployeeReviewSummary : EmployeeReviewSummary = new EmployeeReviewSummary();
    EmployeeReviewSummaryStatus : EmployeeReviewSummaryStatus = new EmployeeReviewSummaryStatus();
    EmployeeReviewSummaryType : EmployeeReviewSummaryType = new EmployeeReviewSummaryType();
    EthosUser : EthosUser = new EthosUser();
    EthosUserDiff : EthosUserDiff = new EthosUserDiff();
    EthosUserSkill : EthosUserSkill = new EthosUserSkill();
    EthosWachterDepartment : EthosWachterDepartment = new EthosWachterDepartment();
    EthosWachterTeam : EthosWachterTeam = new EthosWachterTeam();
    RoEmployeeReviewSummaryCurrent : RoEmployeeReviewSummaryCurrent = new RoEmployeeReviewSummaryCurrent();
    RoEthosUser : RoEthosUser = new RoEthosUser();
    RoEthosUserOriginal : RoEthosUserOriginal = new RoEthosUserOriginal();
    WachterContainerStyle : WachterContainerStyle = new WachterContainerStyle();
}

// Generated Classes for MetaData service
class EmployeeReview implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReview.';

    constructor() {
        this.ItemDetail.ItemId=2651;
        this.ItemDetail.ItemName='EmployeeReview';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewId : string = this.i + 'EmployeeReviewId';
    EmployeeReviewStatusId : string = this.i + 'EmployeeReviewStatusId';
    IsSupervisorReview : string = this.i + 'IsSupervisorReview';
    ResponsibleForBidding : string = this.i + 'ResponsibleForBidding';
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    ResponsibleForRevenue : string = this.i + 'ResponsibleForRevenue';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    DueDate : string = this.i + 'DueDate';
    SubmittedDateTime : string = this.i + 'SubmittedDateTime';

    Relations = {
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReview|EmployeeReviewAnswer|EmployeeReviewId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
            /** Relation: Employee Review Status */
            EmployeeReviewStatus : {
                RelationName: 'EmployeeReviewStatus|EmployeeReview|EmployeeReviewStatusId',
                FieldPrefix: 'EmployeeReviewStatus',
                PropertyName: 'EmployeeReviewStatus'
            },
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmployeeReviewSummary|EmployeeReview|EmployeeReviewSummaryId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
    };
}

class EmployeeReviewAnswer implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewAnswer.';

    constructor() {
        this.ItemDetail.ItemId=2658;
        this.ItemDetail.ItemName='EmployeeReviewAnswer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmplyeeReviewAnswerId : string = this.i + 'EmplyeeReviewAnswerId';
    EmployeeReviewId : string = this.i + 'EmployeeReviewId';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';
    EmployeeReviewAnswerValueId : string = this.i + 'EmployeeReviewAnswerValueId';
    AnswerValueText : string = this.i + 'AnswerValueText';

    Relations = {
            /** Relation: Employee Review Answer Value */
            EmployeeReviewAnswerValue : {
                RelationName: 'EmployeeReviewAnswerValue|EmployeeReviewAnswer|EmployeeReviewAnswerValueId',
                FieldPrefix: 'EmployeeReviewAnswerValue',
                PropertyName: 'EmployeeReviewAnswerValue'
            },
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewAnswer|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReview|EmployeeReviewAnswer|EmployeeReviewId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
    };
}

class EmployeeReviewAnswerValue implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewAnswerValue.';

    constructor() {
        this.ItemDetail.ItemId=2655;
        this.ItemDetail.ItemName='EmployeeReviewAnswerValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewAnswerValueId : string = this.i + 'EmployeeReviewAnswerValueId';
    AnswerDisplay : string = this.i + 'AnswerDisplay';
    AnswerDescription : string = this.i + 'AnswerDescription';
    Weight : string = this.i + 'Weight';

    Relations = {
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReviewAnswerValue|EmployeeReviewAnswer|EmployeeReviewAnswerValueId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
    };
}

class EmployeeReviewCategory implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewCategory.';

    constructor() {
        this.ItemDetail.ItemId=2656;
        this.ItemDetail.ItemName='EmployeeReviewCategory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewCategoryId : string = this.i + 'EmployeeReviewCategoryId';
    ReviewCategory : string = this.i + 'ReviewCategory';
    IconClasses : string = this.i + 'IconClasses';
    WachterContainerStyleId : string = this.i + 'WachterContainerStyleId';
    ReviewCategoryDescriptionHtml : string = this.i + 'ReviewCategoryDescriptionHtml';

    Relations = {
            /** Relation: Wachter Container Style */
            WachterContainerStyle : {
                RelationName: 'WachterContainerStyle|EmployeeReviewCategory|WachterContainerStyleId',
                FieldPrefix: 'WachterContainerStyle',
                PropertyName: 'WachterContainerStyle'
            },
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewCategory|EmployeeReviewQuestion|EmployeeReviewCategoryId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

class EmployeeReviewQuestion implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestion.';

    constructor() {
        this.ItemDetail.ItemId=2657;
        this.ItemDetail.ItemName='EmployeeReviewQuestion';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';
    EmployeeReviewCategoryId : string = this.i + 'EmployeeReviewCategoryId';
    Question : string = this.i + 'Question';
    QuestionDetail : string = this.i + 'QuestionDetail';
    EmployeeReviewQuestionTypeId : string = this.i + 'EmployeeReviewQuestionTypeId';
    QuestionOrder : string = this.i + 'QuestionOrder';
    EmployeeReviewQuestionSkillId : string = this.i + 'EmployeeReviewQuestionSkillId';
    EffectiveStartDate : string = this.i + 'EffectiveStartDate';
    EffectiveEndDate : string = this.i + 'EffectiveEndDate';

    Relations = {
            /** Relation: Employee Review Question Request Detail */
            EmployeeReviewQuestionRequestDetail : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestionRequestDetail',
                PropertyName: 'EmployeeReviewQuestionRequestDetail'
            },
            /** Relation: Employee Review Question Type */
            EmployeeReviewQuestionType : {
                RelationName: 'EmployeeReviewQuestionType|EmployeeReviewQuestion|EmployeeReviewQuestionTypeId',
                FieldPrefix: 'EmployeeReviewQuestionType',
                PropertyName: 'EmployeeReviewQuestionType'
            },
            /** Relation: Employee Review Question Skill */
            EmployeeReviewQuestionSkill : {
                RelationName: 'EmployeeReviewQuestionSkill|EmployeeReviewQuestion|EmployeeReviewQuestionSkillId',
                FieldPrefix: 'EmployeeReviewQuestionSkill',
                PropertyName: 'EmployeeReviewQuestionSkill'
            },
            /** Relation: Employee Review Category */
            EmployeeReviewCategory : {
                RelationName: 'EmployeeReviewCategory|EmployeeReviewQuestion|EmployeeReviewCategoryId',
                FieldPrefix: 'EmployeeReviewCategory',
                PropertyName: 'EmployeeReviewCategory'
            },
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewAnswer|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
            /** Relation: Employee Review Question Setup Detail */
            EmployeeReviewQuestionSetupDetail : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestionSetupDetail',
                PropertyName: 'EmployeeReviewQuestionSetupDetail'
            },
    };
}

class EmployeeReviewQuestionRequest implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequest.';

    constructor() {
        this.ItemDetail.ItemId=2668;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestId : string = this.i + 'EmployeeReviewQuestionRequestId';
    EmployeeReviewQuestionRequestStatusId : string = this.i + 'EmployeeReviewQuestionRequestStatusId';
    SubmittedByEthosUserId : string = this.i + 'SubmittedByEthos_UserId';
    SubmittedByDateTime : string = this.i + 'SubmittedByDateTime';
    RejectedByEthosUserId : string = this.i + 'RejectedByEthos_UserId';
    RejectedByDateTime : string = this.i + 'RejectedByDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    ApprovedByEthosUserId : string = this.i + 'ApprovedByEthos_UserId';
    ApprovedByDateTime : string = this.i + 'ApprovedByDateTime';

    Relations = {
            /** Relation: Ro Ethos User - Rejected By */
            RoEthosUserByRejectedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|RejectedBy',
                FieldPrefix: 'RejectedByEthosRoEthosUser',
                PropertyName: 'RejectedByEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Submitted By */
            RoEthosUserBySubmittedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|SubmittedBy',
                FieldPrefix: 'SubmittedByEthosRoEthosUser',
                PropertyName: 'SubmittedByEthosRoEthosUser'
            },
            /** Relation: Employee Review Question Request Status */
            EmployeeReviewQuestionRequestStatus : {
                RelationName: 'EmployeeReviewQuestionRequestStatus|EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestStatusId',
                FieldPrefix: 'EmployeeReviewQuestionRequestStatus',
                PropertyName: 'EmployeeReviewQuestionRequestStatus'
            },
            /** Relation: Employee Review Question Request Detail */
            EmployeeReviewQuestionRequestDetail : {
                RelationName: 'EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionRequestId',
                FieldPrefix: 'EmployeeReviewQuestionRequestDetail',
                PropertyName: 'EmployeeReviewQuestionRequestDetail'
            },
    };
}

class EmployeeReviewQuestionRequestDetail implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequestDetail.';

    constructor() {
        this.ItemDetail.ItemId=2669;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequestDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestDetailId : string = this.i + 'EmployeeReviewQuestionRequestDetailId';
    EmployeeReviewQuestionRequestId : string = this.i + 'EmployeeReviewQuestionRequestId';
    Question : string = this.i + 'Question';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';

    Relations = {
            /** Relation: Employee Review Question Request */
            EmployeeReviewQuestionRequest : {
                RelationName: 'EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionRequestId',
                FieldPrefix: 'EmployeeReviewQuestionRequest',
                PropertyName: 'EmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

class EmployeeReviewQuestionRequestStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequestStatus.';

    constructor() {
        this.ItemDetail.ItemId=2667;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequestStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestStatusId : string = this.i + 'EmployeeReviewQuestionRequestStatusId';
    ReviewStatus : string = this.i + 'ReviewStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';
    CurrentStatusActionText : string = this.i + 'CurrentStatusActionText';

    Relations = {
            /** Relation: Employee Review Question Request */
            EmployeeReviewQuestionRequest : {
                RelationName: 'EmployeeReviewQuestionRequestStatus|EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestStatusId',
                FieldPrefix: 'EmployeeReviewQuestionRequest',
                PropertyName: 'EmployeeReviewQuestionRequest'
            },
    };
}

class EmployeeReviewQuestionSetup implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetup.';

    constructor() {
        this.ItemDetail.ItemId=2671;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupId : string = this.i + 'EmployeeReviewQuestionSetupId';
    EmployeeReviewQuestionSetupLevelId : string = this.i + 'EmployeeReviewQuestionSetupLevelId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    ReviewYear : string = this.i + 'ReviewYear';
    HideRevenueQuestions : string = this.i + 'HideRevenueQuestions';
    HideBiddingQuestions : string = this.i + 'HideBiddingQuestions';

    Relations = {
            /** Relation: Employee Review Question Setup Detail */
            EmployeeReviewQuestionSetupDetail : {
                RelationName: 'EmployeeReviewQuestionSetup|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionSetupId',
                FieldPrefix: 'EmployeeReviewQuestionSetupDetail',
                PropertyName: 'EmployeeReviewQuestionSetupDetail'
            },
            /** Relation: Employee Review Question Setup Level */
            EmployeeReviewQuestionSetupLevel : {
                RelationName: 'EmployeeReviewQuestionSetupLevel|EmployeeReviewQuestionSetup|EmployeereviewQuestionSetupLevelId',
                FieldPrefix: 'EmployeeReviewQuestionSetupLevel',
                PropertyName: 'EmployeeReviewQuestionSetupLevel'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|EmployeeReviewQuestionSetup|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|EmployeeReviewQuestionSetup|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
    };
}

class EmployeeReviewQuestionSetupDetail implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetupDetail.';

    constructor() {
        this.ItemDetail.ItemId=2672;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetupDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupDetailId : string = this.i + 'EmployeeReviewQuestionSetupDetailId';
    EmployeeReviewQuestionSetupId : string = this.i + 'EmployeeReviewQuestionSetupId';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'EmployeeReviewQuestionSetup|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionSetupId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
    };
}

class EmployeeReviewQuestionSetupLevel implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetupLevel.';

    constructor() {
        this.ItemDetail.ItemId=2670;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetupLevel';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupLevelId : string = this.i + 'EmployeeReviewQuestionSetupLevelId';
    SetupLevel : string = this.i + 'SetupLevel';
    IconClass : string = this.i + 'IconClass';

    Relations = {
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'EmployeeReviewQuestionSetupLevel|EmployeeReviewQuestionSetup|EmployeereviewQuestionSetupLevelId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
    };
}

class EmployeeReviewQuestionSkill implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSkill.';

    constructor() {
        this.ItemDetail.ItemId=2666;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSkillId : string = this.i + 'EmployeeReviewQuestionSkillId';
    SkillName : string = this.i + 'SkillName';
    IsSoftSkill : string = this.i + 'IsSoftSkill';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestionSkill|EmployeeReviewQuestion|EmployeeReviewQuestionSkillId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

class EmployeeReviewQuestionType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionType.';

    constructor() {
        this.ItemDetail.ItemId=2659;
        this.ItemDetail.ItemName='EmployeeReviewQuestionType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionTypeId : string = this.i + 'EmployeeReviewQuestionTypeId';
    QuestionType : string = this.i + 'QuestionType';
    IsSoftSkill : string = this.i + 'IsSoftSkill';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestionType|EmployeeReviewQuestion|EmployeeReviewQuestionTypeId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

class EmployeeReviewStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewStatus.';

    constructor() {
        this.ItemDetail.ItemId=2650;
        this.ItemDetail.ItemName='EmployeeReviewStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewStatusId : string = this.i + 'EmployeeReviewStatusId';
    ReviewStatus : string = this.i + 'ReviewStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReviewStatus|EmployeeReview|EmployeeReviewStatusId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
    };
}

class EmployeeReviewSummary implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummary.';

    constructor() {
        this.ItemDetail.ItemId=2654;
        this.ItemDetail.ItemName='EmployeeReviewSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthosUserId';
    SupervisorEthosUserId : string = this.i + 'SupervisorEthosUserId';
    ReviewYear : string = this.i + 'ReviewYear';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    DueDate : string = this.i + 'DueDate';
    ReviewNotes : string = this.i + 'ReviewNotes';
    CompletedByEthosUserId : string = this.i + 'CompletedByEthos_UserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    ShowGraph : string = this.i + 'ShowGraph';

    Relations = {
            /** Relation: Employee Review Summary Type */
            EmployeeReviewSummaryType : {
                RelationName: 'EmployeeReviewSummaryType|EmployeeReviewSummary|EmployeeReviewSummaryTypeId',
                FieldPrefix: 'EmployeeReviewSummaryType',
                PropertyName: 'EmployeeReviewSummaryType'
            },
            /** Relation: Ethos User - Supervisor */
            EthosUserBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|SupervisorEthosUserId',
                FieldPrefix: 'SupervisorEthosEthosUser',
                PropertyName: 'SupervisorEthosEthosUser'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Emplyoee Review Summary Status */
            EmployeeReviewSummaryStatus : {
                RelationName: 'EmplyoeeReviewSummaryStatus|EmployeeReviewSummary|EmployeeReviewSummaryStatusId',
                FieldPrefix: 'EmployeeReviewSummaryStatus',
                PropertyName: 'EmployeeReviewSummaryStatus'
            },
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReviewSummary|EmployeeReview|EmployeeReviewSummaryId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
    };
}

class EmployeeReviewSummaryStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummaryStatus.';

    constructor() {
        this.ItemDetail.ItemId=2653;
        this.ItemDetail.ItemName='EmployeeReviewSummaryStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    ReviewSummaryStatus : string = this.i + 'ReviewSummaryStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmplyoeeReviewSummaryStatus|EmployeeReviewSummary|EmployeeReviewSummaryStatusId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
    };
}

class EmployeeReviewSummaryType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummaryType.';

    constructor() {
        this.ItemDetail.ItemId=2652;
        this.ItemDetail.ItemName='EmployeeReviewSummaryType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    ReviewSummaryType : string = this.i + 'ReviewSummaryType';

    Relations = {
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmployeeReviewSummaryType|EmployeeReviewSummary|EmployeeReviewSummaryTypeId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
    };
}

class EthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos User - Supervisor User - Many */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User2',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Employee Review Summary - Employee Ethos - Many */
            EmployeeReviewSummaryByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEmployeeReviewSummary',
                PropertyName: 'EmployeeEthosEmployeeReviewSummary'
            },
            /** Relation: Ro Employee Review Summary Current - Employee Ethos - Many */
            RoEmployeeReviewSummaryCurrentByEmployeeEthosUserId : {
                RelationName: 'roEmployeeReviewSummaryCurrent|EthosUser|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosRoEmployeeReviewSummaryCurrent',
                PropertyName: 'EmployeeEthosRoEmployeeReviewSummaryCurrent'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Employee Review Summary - Supervisor Ethos - Many */
            EmployeeReviewSummaryBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|SupervisorEthosUserId',
                FieldPrefix: 'SupervisorEthosEmployeeReviewSummary',
                PropertyName: 'SupervisorEthosEmployeeReviewSummary'
            },
    };
}

class EthosUserDiff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
    };
}

class EthosUserSkill implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Dislay : string = this.i + 'Dislay';
    Meaning : string = this.i + 'Meaning';

    Relations = {
    };
}

class EthosWachterDepartment implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2388;
        this.ItemDetail.ItemName='Ethos_WachterDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentTypeCv : string = this.i + 'DepartmentTypeCv';
    DepartmentTypeMeaning : string = this.i + 'DepartmentTypeMeaning';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DepartmentDirectorUserId : string = this.i + 'DepartmentDirectorUserId';
    IsDeleted : string = this.i + 'IsDeleted';
    DepartmentManagerUserId : string = this.i + 'DepartmentManagerUserId';
    DepartmentAsstManagerUserId : string = this.i + 'DepartmentAsstManagerUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'Ethos_WachterDepartment|EmployeeReviewQuestionSetup|WachterDepartmentId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

class EthosWachterTeam implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterTeam.';

    constructor() {
        this.ItemDetail.ItemId=2412;
        this.ItemDetail.ItemName='Ethos_WachterTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamTypeCv : string = this.i + 'TeamTypeCv';
    TeamTypeMeaning : string = this.i + 'TeamTypeMeaning';
    TeamName : string = this.i + 'TeamName';
    TeamLeaderUserId : string = this.i + 'TeamLeaderUserId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    IsDeleted : string = this.i + 'IsDeleted';
    OverheadJobNumberId : string = this.i + 'OverheadJobNumberId';
    OverheadJobNumberPhaseId : string = this.i + 'OverheadJobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'Ethos_WachterTeam|EmployeeReviewQuestionSetup|WachterTeamId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
    };
}

class RoEmployeeReviewSummaryCurrent implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEmployeeReviewSummaryCurrent.';

    constructor() {
        this.ItemDetail.ItemId=2690;
        this.ItemDetail.ItemName='roEmployeeReviewSummaryCurrent';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthosUserId';
    SupervisorEthosUserId : string = this.i + 'SupervisorEthosUserId';
    ReviewYear : string = this.i + 'ReviewYear';
    DueDate : string = this.i + 'DueDate';
    ReviewNotes : string = this.i + 'ReviewNotes';
    CompletedByEthosUserId : string = this.i + 'CompletedByEthos_UserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Employee Ethos User */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'roEmployeeReviewSummaryCurrent|EthosUser|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
    };
}

class RoEthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Employee Review Question Request - User Id - Many */
            EmployeeReviewQuestionRequestByRejectedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|RejectedBy',
                FieldPrefix: 'RejectedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'RejectedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Employee Review Question Request - User Id - Many */
            EmployeeReviewQuestionRequestBySubmittedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|SubmittedBy',
                FieldPrefix: 'SubmittedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'SubmittedByEthosEmployeeReviewQuestionRequest'
            },
    };
}

class RoEthosUserOriginal implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

class WachterContainerStyle implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WachterContainerStyle.';

    constructor() {
        this.ItemDetail.ItemId=2660;
        this.ItemDetail.ItemName='WachterContainerStyle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterContainerStyleId : string = this.i + 'WachterContainerStyleId';
    StyleDisplay : string = this.i + 'StyleDisplay';
    StyleKey : string = this.i + 'StyleKey';

    Relations = {
            /** Relation: Employee Review Category */
            EmployeeReviewCategory : {
                RelationName: 'WachterContainerStyle|EmployeeReviewCategory|WachterContainerStyleId',
                FieldPrefix: 'EmployeeReviewCategory',
                PropertyName: 'EmployeeReviewCategory'
            },
    };
}


// Generated Entity Interfaces
export interface EmployeeReviewEntity extends DwOrmData {
    // Attributes
    EmployeeReviewId?: number;
    EmployeeReviewStatusId?: number;
    IsSupervisorReview?: boolean;
    ResponsibleForBidding?: boolean;
    EmployeeReviewSummaryId?: number;
    ResponsibleForRevenue?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    DueDate?: string;
    SubmittedDateTime?: string;

    // Display Attributes
    EmployeeReviewStatusIdDisplay?: string;
    EmployeeReviewSummaryIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    // Relations
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
    EmployeeReviewStatus? : EmployeeReviewStatusEntity;
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity;
}

export interface EmployeeReviewAnswerEntity extends DwOrmData {
    // Attributes
    EmplyeeReviewAnswerId?: number;
    EmployeeReviewId?: number;
    EmployeeReviewQuestionId?: number;
    EmployeeReviewAnswerValueId?: number;
    AnswerValueText?: string;

    // Display Attributes
    EmployeeReviewIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;
    EmployeeReviewAnswerValueIdDisplay?: string;
    // Relations
    EmployeeReviewAnswerValue? : EmployeeReviewAnswerValueEntity;
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
    EmployeeReview? : EmployeeReviewEntity;
}

export interface EmployeeReviewAnswerValueEntity extends DwOrmData {
    // Attributes
    EmployeeReviewAnswerValueId?: number;
    AnswerDisplay?: string;
    AnswerDescription?: string;
    Weight?: number;

    // Relations
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
}

export interface EmployeeReviewCategoryEntity extends DwOrmData {
    // Attributes
    EmployeeReviewCategoryId?: number;
    ReviewCategory?: string;
    IconClasses?: string;
    WachterContainerStyleId?: number;
    ReviewCategoryDescriptionHtml?: string;

    // Display Attributes
    WachterContainerStyleIdDisplay?: string;
    // Relations
    WachterContainerStyle? : WachterContainerStyleEntity;
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewQuestionEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionId?: number;
    EmployeeReviewCategoryId?: number;
    Question?: string;
    QuestionDetail?: string;
    EmployeeReviewQuestionTypeId?: number;
    QuestionOrder?: number;
    EmployeeReviewQuestionSkillId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;

    // Display Attributes
    EmployeeReviewCategoryIdDisplay?: string;
    EmployeeReviewQuestionTypeIdDisplay?: string;
    EmployeeReviewQuestionSkillIdDisplay?: string;
    // Relations
    EmployeeReviewQuestionRequestDetail? : EmployeeReviewQuestionRequestDetailEntity[];
    EmployeeReviewQuestionType? : EmployeeReviewQuestionTypeEntity;
    EmployeeReviewQuestionSkill? : EmployeeReviewQuestionSkillEntity;
    EmployeeReviewCategory? : EmployeeReviewCategoryEntity;
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
    EmployeeReviewQuestionSetupDetail? : EmployeeReviewQuestionSetupDetailEntity[];
}

export interface EmployeeReviewQuestionRequestEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestId?: number;
    EmployeeReviewQuestionRequestStatusId?: number;
    SubmittedByEthos_UserId?: number;
    SubmittedByDateTime?: string;
    RejectedByEthos_UserId?: number;
    RejectedByDateTime?: string;
    RejectedNotes?: string;
    ApprovedByEthos_UserId?: number;
    ApprovedByDateTime?: string;

    // Display Attributes
    EmployeeReviewQuestionRequestStatusIdDisplay?: string;
    SubmittedByEthos_UserIdDisplay?: string;
    RejectedByEthos_UserIdDisplay?: string;
    ApprovedByEthos_UserIdDisplay?: string;
    // Relations
    RejectedByEthosRoEthosUser? : RoEthosUserEntity;
    SubmittedByEthosRoEthosUser? : RoEthosUserEntity;
    EmployeeReviewQuestionRequestStatus? : EmployeeReviewQuestionRequestStatusEntity;
    EmployeeReviewQuestionRequestDetail? : EmployeeReviewQuestionRequestDetailEntity[];
}

export interface EmployeeReviewQuestionRequestDetailEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestDetailId?: number;
    EmployeeReviewQuestionRequestId?: number;
    Question?: string;
    EmployeeReviewQuestionId?: number;

    // Display Attributes
    EmployeeReviewQuestionRequestIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;
    // Relations
    EmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity;
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
}

export interface EmployeeReviewQuestionRequestStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestStatusId?: number;
    ReviewStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;
    CurrentStatusActionText?: string;

    // Relations
    EmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
}

export interface EmployeeReviewQuestionSetupEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupId?: number;
    EmployeeReviewQuestionSetupLevelId?: number;
    WachterDepartmentId?: number;
    WachterTeamId?: number;
    ReviewYear?: number;
    HideRevenueQuestions?: boolean;
    HideBiddingQuestions?: boolean;

    // Display Attributes
    EmployeeReviewQuestionSetupLevelIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    // Relations
    EmployeeReviewQuestionSetupDetail? : EmployeeReviewQuestionSetupDetailEntity[];
    EmployeeReviewQuestionSetupLevel? : EmployeeReviewQuestionSetupLevelEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface EmployeeReviewQuestionSetupDetailEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupDetailId?: number;
    EmployeeReviewQuestionSetupId?: number;
    EmployeeReviewQuestionId?: number;

    // Display Attributes
    EmployeeReviewQuestionSetupIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;
    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity;
}

export interface EmployeeReviewQuestionSetupLevelEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupLevelId?: number;
    SetupLevel?: string;
    IconClass?: string;

    // Relations
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
}

export interface EmployeeReviewQuestionSkillEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSkillId?: number;
    SkillName?: string;
    IsSoftSkill?: boolean;

    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewQuestionTypeEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionTypeId?: number;
    QuestionType?: string;
    IsSoftSkill?: boolean;

    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewStatusId?: number;
    ReviewStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;

    // Relations
    EmployeeReview? : EmployeeReviewEntity[];
}

export interface EmployeeReviewSummaryEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryId?: number;
    EmployeeReviewSummaryStatusId?: number;
    EmployeeReviewSummaryTypeId?: number;
    EmployeeEthosUserId?: number;
    SupervisorEthosUserId?: number;
    ReviewYear?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    DueDate?: string;
    ReviewNotes?: string;
    CompletedByEthos_UserId?: number;
    CompletedByDateTime?: string;
    ShowGraph?: boolean;

    // Display Attributes
    EmployeeReviewSummaryStatusIdDisplay?: string;
    EmployeeReviewSummaryTypeIdDisplay?: string;
    EmployeeEthosUserIdDisplay?: string;
    SupervisorEthosUserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    CompletedByEthos_UserIdDisplay?: string;
    // Relations
    EmployeeReviewSummaryType? : EmployeeReviewSummaryTypeEntity;
    SupervisorEthosEthosUser? : EthosUserEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    EmployeeReviewSummaryStatus? : EmployeeReviewSummaryStatusEntity;
    EmployeeReview? : EmployeeReviewEntity[];
}

export interface EmployeeReviewSummaryStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryStatusId?: number;
    ReviewSummaryStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;

    // Relations
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
}

export interface EmployeeReviewSummaryTypeEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryTypeId?: number;
    ReviewSummaryType?: string;

    // Relations
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserTypeCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    // Relations
    SupervisorEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    EmployeeEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EmployeeEthosRoEmployeeReviewSummaryCurrent? : RoEmployeeReviewSummaryCurrentEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Relations
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Dislay?: string;
    Meaning?: string;

    // Relations
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    // Relations
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
    EthosWachterTeam? : EthosWachterTeamEntity[];
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterTeamEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamTypeCv?: number;
    TeamTypeMeaning?: string;
    TeamName?: string;
    TeamLeaderUserId?: number;
    AxIntegrationId?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    IsDeleted?: boolean;
    OverheadJobNumberId?: number;
    OverheadJobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;
    TeamLeaderUserIdDisplay?: string;
    // Relations
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
}

export interface RoEmployeeReviewSummaryCurrentEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryId?: number;
    EmployeeReviewSummaryStatusId?: number;
    EmployeeReviewSummaryTypeId?: number;
    EmployeeEthosUserId?: number;
    SupervisorEthosUserId?: number;
    ReviewYear?: number;
    DueDate?: string;
    ReviewNotes?: string;
    CompletedByEthos_UserId?: number;
    CompletedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Relations
    EmployeeEthosEthosUser? : EthosUserEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;

    // Display Attributes
    UserTypeCvDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    // Relations
    EthosUser? : EthosUserEntity;
    RejectedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    SupervisorRoEthosUser? : RoEthosUserEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
    SubmittedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: string;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;

    // Relations
}

export interface WachterContainerStyleEntity extends DwOrmData {
    // Attributes
    WachterContainerStyleId?: number;
    StyleDisplay?: string;
    StyleKey?: string;

    // Relations
    EmployeeReviewCategory? : EmployeeReviewCategoryEntity[];
}

    // Lookup Value Enums  {
export enum EmployeeReviewStatusAllItems {
        NotStarted = 1,
        InProgress = 2,
        Submitted = 3,
        Complete = 4,
        Deleted = 5,
    }

export enum EmployeeReviewSummaryStatusAllItems {
        NotStarted = 1,
        InProgress = 2,
        WaitingOnEmployee = 3,
        ReadyForReview = 4,
        Complete = 6,
        Deleted = 7,
    }

export enum EmployeeReviewQuestionRequestStatusAllItems {
        Draft = 1,
        Submitted = 2,
        Approved = 3,
        Rejected = 4,
    }

export enum EmployeeReviewSummaryTypeAllItems {
        AnnualReview = 1,
        PeriodicReview = 2,
    }

export enum EmployeeReviewQuestionTypeAllItems {
        SkillQuestion = 1,
        CustomQuestion = 2,
    }

export enum EmployeeReviewQuestionSetupLevelAllItems {
        Global = 1,
        Department = 2,
        Team = 3,
    }

export enum EmployeeReviewCategoryAllItems {
        General = 1,
        Bidding = 2,
        Revenue = 3,
        EmployeeEvaluation = 4,
    }




